module.exports = __webpack_public_path__ + "static/weertelaatbe-logo-ee7e760c0e85245153c926d0b6823980.png";